import React,{ useState } from "react"
import { postEventApplication_2 } from "../Api"
import PropTypes from 'prop-types';

export default function EventApplication(props) {
  const [name, setName] = useState("")
  const [phone, setPhone] = useState("")
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [region, setRegion] = useState("")
  const [regionOthers, setRegionOthers] = useState("")
  const [open_quiz_1, setOpen_quiz_1] = useState('')//How often do you buy mobile data bundles
  const [open_quiz_2, setOpen_quiz_2] = useState('') //On average, how much do you spend on mobile data each month?
  const [open_quiz_3, setOpen_quiz_3] = useState([]) //What do you primarily use mobile data for
  const [open_quiz_3_other, setOpen_quiz_3_other] = useState('');
  const [open_quiz_4, setOpen_quiz_4] = useState([]) //Which mobile data provider do you currently use most
  const [open_quiz_4_other, setOpen_quiz_4_other] = useState('');
  const [open_quiz_5, setOpen_quiz_5] = useState('');  //How satisfied are you with your current mobile data provider?
  const [open_quiz_6, setOpen_quiz_6] = useState('');  //Are you currently using Konnect Internet at home or in your area?
  const [open_quiz_7, setOpen_quiz_7] = useState([]); // Which Konnect Internet package(s) do you mostly subscribe to
  const [open_quiz_8, setOpen_quiz_8] = useState([]); //Where do you mostly need mobile data when away from Konnect coverage
  const [open_quiz_8_other, setOpen_quiz_8_other] = useState('');
  const [open_quiz_9, setOpen_quiz_9] = useState('');  //If Konnect offered more affordable 4G data bundles that work on your existing SIM, how interested would you be
  const [open_quiz_10, setOpen_quiz_10] = useState([]); //What would motivate you to try Konnect 4G bundles? 
  const [open_quiz_10_other, setOpen_quiz_10_other] = useState('');
  const [open_quiz_11, setOpen_quiz_11] = useState([]); // Which of the following bundles would you likely purchase
  const [message_quiz_1, setMessage_quiz_1] = useState("") //What challenges do you currently face with mobile data that Konnect could help solve
  const [open_quiz_12, setOpen_quiz_12] = useState("")

  
  // const [message_quiz_2, setMessage_quiz_2] = useState("")
  // const [message_quiz_3, setMessage_quiz_3] = useState("")
  // const [message_quiz_4, setMessage_quiz_4] = useState("")
  // const [message_quiz_5, setMessage_quiz_5] = useState("")
  // const [message_quiz_6, setMessage_quiz_6] = useState("")
  // const [message_quiz_7, setMessage_quiz_7] = useState("")
  // const [message_quiz_8, setMessage_quiz_8] = useState("")
  // const [message_quiz_9, setMessage_quiz_9] = useState("")
  // const [message_quiz_10, setMessage_quiz_10] = useState("")
  // const [selectedFile, setSelectedFile] = useState(null)

  const handleCheckboxChange = (setFunc) => (event) => {
    const { value, checked } = event.target;
    setFunc((prev) =>
      checked ? [...prev, value] : prev.filter((item) => item !== value)
    );
  };

  const handleRadioChange = (setFunc) => (event) => {
    setFunc(event.target.value);
  };


    const handleSubmit = async (event) => {
      event.preventDefault();
      setLoading(true);
  
      const data = {
        title: props?.title,
        phone: phone,
        name: name,
        residency: region,
        residency_other: regionOthers,
        open_quiz_1: open_quiz_1,
        open_quiz_2: open_quiz_2,
        open_quiz_3: open_quiz_3.includes('Other')
             ? [...open_quiz_3.filter((option) => option !== "Other"), `Other: ${open_quiz_3_other}`].join(', ')
             : open_quiz_3.join(', '),
        open_quiz_4: open_quiz_4.includes('Other')
             ? [...open_quiz_4.filter((option) => option !== "Other"), `Other: ${open_quiz_4_other}`].join(', ')
             : open_quiz_4.join(', '),

        open_quiz_5: open_quiz_5,
        open_quiz_6: open_quiz_6,
        open_quiz_7: open_quiz_7.join(', '),
        open_quiz_8: open_quiz_8.includes('Other')
             ? [...open_quiz_8.filter((option) => option !== "Other"), `Other: ${open_quiz_8_other}`].join(', ')
             : open_quiz_8.join(', '),

        
        open_quiz_9: open_quiz_9,
        open_quiz_10: open_quiz_10.includes('Other')
             ? [...open_quiz_10.filter((option) => option !== "Other"), `Other: ${open_quiz_10_other}`].join(', ')
             : open_quiz_10.join(', '),

       open_quiz_11: open_quiz_11.join(', '),
       open_quiz_12:open_quiz_12,
        // open_quiz_10: open_quiz_10 ? "Yes" : "No",
        message_quiz_1: message_quiz_1,
  
      };
  
      console.log(data);
  
      postEventApplication_2(data).then((msg) => {
        setName('');
        setPhone('');
        setRegion('');
        setRegionOthers('');
        setOpen_quiz_1('');
        setOpen_quiz_2('');
        setOpen_quiz_3([]);
        setOpen_quiz_3_other('');
        setOpen_quiz_4([]);
        setOpen_quiz_4_other('');
        setOpen_quiz_5('');
        setOpen_quiz_6('');
        setOpen_quiz_7([]);

        setOpen_quiz_8([]);
        setOpen_quiz_8_other('');
        setOpen_quiz_9('');


        setOpen_quiz_10([]);
        setOpen_quiz_10_other('');
        setOpen_quiz_11([]);
        setOpen_quiz_12("")

        setMessage_quiz_1("")

        setLoading(false);
  
        if (msg !== false) {
          setSuccess(true);
          props.onFormSubmitSuccess();
        }
      });
  };
  
  return (
    <div
      style={{
        width: "100%",
        minHeight: "60vh",
        maxWidth: 800,
        backgroundColor: !success ? "#e5e5e5" : "white",
        padding: 10,
        borderRadius: 10,
      }}
    >
      {success === false && (
        <form onSubmit={handleSubmit}>
          <h4>Participate in the Survey</h4>

          {/* Name */}
          {/* <div className="form-group">
            <label htmlFor="name" className="required">
              Name
            </label>
            <input
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              className="form-control"
              id="name"
              placeholder="Enter your full name"
            />
          </div> */}





          <div className="form-group">
            <label className="required">
              1. How often do you buy mobile data bundles? 
            </label>
            <br />
            {["Daily", "Weekly", "Monthly", "Only when needed", "Rarely/Never"].map((option) => (
              <div key={option}>
                <input
                  type="radio"
                  className="input_test"
                  id={`open_quiz_1_${option.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`}
                  name="open_quiz_1"
                  value={option}
                  checked={open_quiz_1 === option.toString()}
                  onChange={handleRadioChange(setOpen_quiz_1)}
                />
                <label htmlFor={`open_quiz_1_${option.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`}>{option}</label>
                <br />
              </div>
            ))}
          </div>



             <div className="form-group">
            <label className="required">
              2. On average, how much do you spend on mobile data each month? 
            </label>
            <br />
            {["Less than Ksh 200", "Ksh 200 – 500", "Ksh 501 – 1,000", "Ksh 1,001 – 2,000","More than Ksh 2,000"].map((option) => (
              <div key={option}>
                <input
                  type="radio"
                  className="input_test"
                  id={`open_quiz_2_${option.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`}
                  name="open_quiz_2"
                  value={option}
                  checked={open_quiz_2 === option.toString()}
                  onChange={handleRadioChange(setOpen_quiz_2)}
                />
                <label htmlFor={`open_quiz_2_${option.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`}>{option}</label>
                <br />
              </div>
            ))}
          </div>

          <div className="form-group">
            <label className="required">
              3. What do you primarily use mobile data for? (Select all that apply)
            </label>
            <br />
            {['Social media (WhatsApp, TikTok, etc.)', 'Video streaming (YouTube, Netflix, etc.)', 'Work or business (Emails, Zoom)','Online learning/study','Gaming','News/general browsing', 'Other'].map((option) => (
              <div key={option}>
                <input
                  type="checkbox"
                  className="input_test"
                  id={`open_quiz_3_${option.replace(/\s+/g, '_')}`}
                  name="open_quiz_3"
                  value={option}
                  checked={open_quiz_3.includes(option)}
                  onChange={handleCheckboxChange(setOpen_quiz_3)}
                />
                <label htmlFor={`open_quiz_3_${option.replace(/\s+/g, '_')}`}>{option}</label>
                <br />
              </div>
            ))}
            {open_quiz_3.includes('Other') && (
              <input
                type="text"
                className="form-control"
                id="open_quiz_3_other"
                name="open_quiz_3_other"
                value={open_quiz_3_other}
                onChange={(e) => setOpen_quiz_3_other(e.target.value)}
                placeholder="Please specify"
              />
            )}
          </div>


           <div className="form-group">
            <label className="required">
              4. Which mobile data provider do you currently use most?
            </label>
            <br />
            {['Safaricom', 'Airtel', 'Telkom', 'Other'].map((option) => (
              <div key={option}>
                <input
                  type="checkbox"
                  className="input_test"
                  id={`open_quiz_4_${option.replace(/\s+/g, '_')}`}
                  name="open_quiz_4"
                  value={option}
                  checked={open_quiz_4.includes(option)}
                  onChange={handleCheckboxChange(setOpen_quiz_4)}
                />
                <label htmlFor={`open_quiz_4_${option.replace(/\s+/g, '_')}`}>{option}</label>
                <br />
              </div>
            ))}
            {open_quiz_4.includes('Other') && (
              <input
                type="text"
                className="form-control"
                id="open_quiz_4_other"
                name="open_quiz_4_other"
                value={open_quiz_4_other}
                onChange={(e) => setOpen_quiz_4_other(e.target.value)}
                placeholder="Please specify"
              />
            )}
          </div>


           <div className="form-group">
              <label className="required">
                5. How satisfied are you with your current mobile data provider?
              </label>
              <br />
              {["Very satisfied", "Somewhat satisfied", "Neutral", "Somewhat dissatisfied", "Very dissatisfied"].map((option) => (
                <div key={option}>
                  <input
                    type="radio"
                    className="input_test"
                    id={`open_quiz_5_${option.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`}
                    name="open_quiz_5"
                    value={option}
                    checked={open_quiz_5 === option.toString()}
                    onChange={handleRadioChange(setOpen_quiz_5)}
                  />
                  <label htmlFor={`open_quiz_5_${option.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`}>{option}</label>
                  <br />
                </div>
              ))}
            </div>




            <div className="form-group">
              <label className="required">
                6. Are you currently using Konnect Internet at home or in your area?
            </label>
              <br />
              {["Yes, daily", "Yes, occasionally", "I used to", "No, not available in my area", "No, I’ve never used it"].map((option) => (
                <div key={option}>
                  <input
                    type="radio"
                    className="input_test"
                    id={`open_quiz_6_${option.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`}
                    name="open_quiz_6"
                    value={option}
                    checked={open_quiz_6 === option.toString()}
                    onChange={handleRadioChange(setOpen_quiz_6)}
                  />
                  <label htmlFor={`open_quiz_6_${option.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`}>{option}</label>
                  <br />
                </div>
              ))}
            </div>


                   <div className="form-group">
            <label className="required">
              7. Which Konnect Internet package(s) do you mostly subscribe to? (Select up to 2)
            </label>
            <br />
            {['Kumi/Mbao (Ksh 10/20)', 'Daily (Ksh 50/80/140)', 'Weekly Solo (Ksh 280)', 'Weekly (Ksh 380)', 'Monthly Solo (Ksh 720)', "Monthly (Ksh 1000)","Family (Ksh 1300-2000)","Quarterly (Ksh 2700-5300)","Not a Konnect Internet user"].map((option) => (
              <div key={option}>
                <input
                  type="checkbox"
                  className="input_test"
                  id={`open_quiz_7_${option.replace(/\s+/g, '_')}`}
                  name="open_quiz_7"
                  value={option}
                  checked={open_quiz_7.includes(option)}
                  onChange={handleCheckboxChange(setOpen_quiz_7)}
                />
                <label htmlFor={`open_quiz_7_${option.replace(/\s+/g, '_')}`}>{option}</label>
                <br />
              </div>
            ))}
          </div>

           <div className="form-group">
            <label className="required">
              8. Where do you mostly need mobile data when away from Konnect coverage?(Select all that apply) 
            </label>
            <br />
            {['At work or school', 'While traveling', 'In public places (malls, bus stops, etc.)','When home internet is down', 'When visiting friends or family','Other'].map((option) => (
              <div key={option}>
                <input
                  type="checkbox"
                  className="input_test"
                  id={`open_quiz_8_${option.replace(/\s+/g, '_')}`}
                  name="open_quiz_8"
                  value={option}
                  checked={open_quiz_8.includes(option)}
                  onChange={handleCheckboxChange(setOpen_quiz_8)}
                />
                <label htmlFor={`open_quiz_8_${option.replace(/\s+/g, '_')}`}>{option}</label>
                <br />
              </div>
            ))}
            {open_quiz_8.includes('Other') && (
              <input
                type="text"
                className="form-control"
                id="open_quiz_8_other"
                name="open_quiz_8_other"
                value={open_quiz_8_other}
                onChange={(e) => setOpen_quiz_8_other(e.target.value)}
                placeholder="Please specify"
              />
            )}
          </div>





             <div className="form-group">
          <label className="required">
                9. If Konnect offered more affordable 4G data bundles that work on your existing SIM, how interested would you be
            </label>
          <br />
           {["Very interested", "Somewhat interested", "Not sure", "Not interested"].map((option) => (
            <div key={option}>
              <input
                type="radio"
                className="input_test"
                id={`open_quiz_9_${option.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`}
                name="open_quiz_9"
                value={option}
                checked={open_quiz_9 === option.toString()}
                onChange={handleRadioChange(setOpen_quiz_9)}
              />
              <label htmlFor={`open_quiz_9_${option.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()}`}>{option}</label>
              <br />
            </div>
          ))}
          </div>
          





          <div className="form-group">
            <label className="required">
              10. What would motivate you to try Konnect 4G bundles? (Select all that apply)
            </label>
            <br />
            {['Cheaper than current providers', 'Works on my current SIM (no switch needed)', 'Seamless top-up via Konnect App','Bonus bundles when I buy Konnect internet','Flexible options (daily, weekly, monthly)', 'Ability to gift or share data','Other'].map((option) => (
              <div key={option}>
                <input
                  type="checkbox"
                  className="input_test"
                  id={`open_quiz_10_${option.replace(/\s+/g, '_')}`}
                  name="open_quiz_10"
                  value={option}
                  checked={open_quiz_10.includes(option)}
                  onChange={handleCheckboxChange(setOpen_quiz_10)}
                />
                <label htmlFor={`open_quiz_10_${option.replace(/\s+/g, '_')}`}>{option}</label>
                <br />
              </div>
            ))}
            {open_quiz_10.includes('Other') && (
              <input
                type="text"
                className="form-control"
                id="open_quiz_10_other"
                name="open_quiz_10_other"
                value={open_quiz_10_other}
                onChange={(e) => setOpen_quiz_10_other(e.target.value)}
                placeholder="Please specify"
              />
            )}
          </div>



          <div className="form-group">
            <label className="required">
              11. Which of the following bundles would you likely purchase? (Select all that apply)
            </label>
            <br />
            {['100MB for Ksh 15 (weekly)', '250MB for Ksh 30 (weekly)', '500MB for Ksh 50 (weekly)', '1GB for Ksh 95 (monthly)', '2GB for Ksh 185 (monthly)', "5GB for Ksh 450 (monthly)","10GB for Ksh 850 (monthly)","20GB for Ksh 1650 (monthly)"].map((option) => (
              <div key={option}>
                <input
                  type="checkbox"
                  className="input_test"
                  id={`open_quiz_11_${option.replace(/\s+/g, '_')}`}
                  name="open_quiz_11"
                  value={option}
                  checked={open_quiz_11.includes(option)}
                  onChange={handleCheckboxChange(setOpen_quiz_11)}
                />
                <label htmlFor={`open_quiz_11_${option.replace(/\s+/g, '_')}`}>{option}</label>
                <br />
              </div>
            ))}
          </div>

         
          <div className="form-group">
            <label htmlFor="message_quiz_1">
             12. What challenges do you currently face with mobile data that Konnect could help solve?
            </label>
            <textarea
              className="form-control"
              id="message_quiz_1"
              value={message_quiz_1}
              onChange={(e) => setMessage_quiz_1(e.target.value)}
              rows={3}
            />
          </div>
         








          {/* ---------------------------------------------------- */}
           {/* Phone */}
          <div className="form-group">
            <label htmlFor="phone" className="required">
              Your Phone registered with Konnect Internet
            </label>
            <input
              required
              type="tel"
              maxLength={13}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="form-control"
              id="phone"
              placeholder="Enter your phone number"
            />
          </div>




           <div className="form-group">
            <label htmlFor="phone">
              Phone to reach you with SMS notification (if different from above)
            </label>
            <input
              type="tel"
              maxLength={13}
              value={open_quiz_12}
              onChange={(e) => setOpen_quiz_12(e.target.value)}
              className="form-control"
              id="open_quiz_12"
              placeholder="Enter your phone number"
            />
          </div>




          {/* Region */}
          <div className="form-group">
            <label htmlFor="region" className="required">
              Region
            </label>
            <select
              required
              className="form-control"
              id="region"
              value={region}
              onChange={(e) => setRegion(e.target.value)}
            >
              <option value="">-- --</option>
              {[
                ["Githurai_44", "Githurai 44"],
                ["Githurai_45", "Githurai 45"],
                ["Roysambu/Mirema", "Roysambu/Mirema"],
                ["Zimmerman", "Zimmerman"],
                ["Kahawa_West", "Kahawa West"],
                ["Kahawa_Wendani", "Kahawa Wendani"],
                ["Kasarani", "Kasarani"],
                ["Hunters", "Hunters"],
                ["Mwiki", "Mwiki"],
                ["Sunton", "Sunton"],
                ["Lucky_Summer/Baba_Dogo/Ngumba", "Lucky Summer/Baba Dogo/Ngumba"],
                ["kariobangi", "Kariobangi"],
                ["Mowlem_Umoja_3", "Mowlem/Umoja 3"],
                ["Umoja", "Umoja"],
                ["Pipeline", "Pipeline"],
                ["Kayole", "Kayole"],
                ["Kibera", "Kibera"],
              ].map(([value, label]) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
              <option value="Other">Other</option>
            </select>
          </div>

          {region === "Other" && (
            <div className="form-group">
              <label htmlFor="regionOthers">Specify region if `Other` is selected</label>
              <input
                value={regionOthers}
                onChange={(e) => setRegionOthers(e.target.value)}
                type="text"
                className="form-control"
                id="regionOthers"
                placeholder="Enter your region"
              />
            </div>
          )}

          


          {/* Submit button */}
          <div style={{ float: 'right' }}>
            {loading ? (
              <button type="button" className="btn btn-warning">
                Loading...
              </button>
            ) : (
              <button type="submit" className="btn btn-warning">
                Submit Survey
              </button>
            )}
          </div>


        </form>
      
      )}




      
      {success && (
  <div style={{ textAlign: 'center', padding: '20px' }}>
    <div className="alert alert-success" role="alert">
        <p className="font-bold">✅ ASANTE SANA! YOUR FEEDBACK IS VALUABLE!</p>
        <p>🎉 You’ve earned a <strong>FREE MBAO Package (2.5 hours)</strong> and entered the <strong>Konnect Lucky Draw!</strong></p>        
    </div>

          
     <div style={{ textAlign: 'left', maxWidth: '600px', margin: '20px auto' }}>
      <p>📲 <strong>What’s Next:</strong></p>
      <ol style={{ paddingLeft: '1.2em' }}>
        <li>
          Download the Konnect App now to receive your reward and prize: <br />
          👉 <a href="https://play.google.com/store/apps/details?id=net.sasakonnect.supper_app&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">Konnect App</a>
        </li>
        <li>
          Watch the Live Lucky Draw on our Facebook page: <br />
          🎥 <a href="https://fb.com/sasakonnect" target="_blank" rel="noopener noreferrer">https://fb.com/sasakonnect</a> <br />
          🕗 <strong>8PM, Wednesday 9th April</strong>
        </li>
        <li>
          Check your SMS after the draw:
          <ul>
            <li>Winners will receive prize notifications</li>
            <li>Your MBAO package will be available to activate in the Konnect App</li>
          </ul>
        </li>
      </ol>

      <p>🎁 Rewards and Prizes valid for activation anytime within 1 month</p>
    </div>



   <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '20px' }}>
  <a
    href="https://play.google.com/store/apps/details?id=net.sasakonnect.supper_app&pcampaignid=web_share"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      padding: '10px 20px',
      backgroundColor: '#28a745',
      color: 'white',
      textDecoration: 'none',
      borderRadius: '5px',
    }}
  >
    DOWNLOAD KONNECT APP
  </a>
  <a
    href="https://karibu.sasakonnect.net"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      padding: '10px 20px',
      backgroundColor: '#007bff',
      color: 'white',
      textDecoration: 'none',
      borderRadius: '5px',
    }}
  >
    BACK
  </a>
</div>



  </div>
)}





    </div>
  )
}



EventApplication.propTypes = {
  title: PropTypes.string.isRequired, // Validate that `title` is a required string
  onFormSubmitSuccess: PropTypes.func.isRequired,
};
